import { combineReducers } from 'redux';
import { reducer as question_explain } from './question_explain';
import { reducer as look_over_question } from './look_over_question';
import { reducer as set_tag } from './set_tag'
import {reducer as evaluating} from './question_evaluating'
import {reducer as imageCorrection} from './image_correction'
import {reducer as questionTML} from './question_tml'

const reducer = combineReducers({
    questionExplain: question_explain,
    lookOverQuestion: look_over_question,
    setTag: set_tag,
    evaluating: evaluating,
    imageCorrection,
    questionTML
});

export default reducer


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/reducer.js